import { RouteProps } from 'react-router';
import RouteGetter from '../RouteGetter';
import { DashboardRoute } from '../types';
import DashboardChart from '../../views/dashboard/Dashboard';
import CurrentUserEdit from '../../views/users/CurrentUserEdit';
import OrganizationForm from '../../views/organizations/OrganizationForm';
import ProjectList from '../../views/projects/ProjectList';
import Project from '../../views/projects/Project';
import InvitationPage from '../../views/pages/invitation/InvitationPage';
import Profile from '../../views/profile/Profile';
import Pricing from '../../views/pages/Pricing/Pricing';
import CheckoutPage from '../../views/pages/checkout/CheckoutPage';

const isDevMode = process.env.REACT_APP_BUILD_ENV === 'development';

export const home = {
  path: '/dashboard/home',
  component: DashboardChart,
} as DashboardRoute;

export const profile = {
  path: '/dashboard/users/profile',
  component: CurrentUserEdit,
} as DashboardRoute;

export const profileAll = {
  path: [
    '/dashboard/profile',
    '/dashboard/profile/me',
    '/dashboard/profile/notifications',
    '/dashboard/profile/admin',
    '/dashboard/profile/billing/plan',
    '/dashboard/profile/billing/payment-method',
    '/dashboard/profile/billing/invoices',
    '/dashboard/profile/billing/credit-history',
  ],
  component: Profile,
} as DashboardRoute;

export const organizationEdit = {
  path: [
    '/dashboard/user/organizations/:id',
    '/dashboard/user/organizations/:id/account',
    '/dashboard/user/organizations/:id/team',
    '/dashboard/user/organizations/:id/billing',
    '/dashboard/user/organizations/:id/team/new',
    '/dashboard/user/organizations/:id/team/:teamId',
  ],
  component: OrganizationForm,
} as DashboardRoute;

export const projectList = {
  path: RouteGetter.get('project').index,
  component: ProjectList,
} as DashboardRoute;

const projectFormPaths = [
  RouteGetter.get('project').newPage(),
  RouteGetter.get('project').newPage(true),
  RouteGetter.get('project').pagePath(),
  RouteGetter.get('project').pagePath(true),
  RouteGetter.get('project').mediaPath(),
  RouteGetter.get('project').scriptsPath(),
  RouteGetter.get('project').activityPath(),
  RouteGetter.get('project').studioPath(),
  RouteGetter.get('project').overviewPath(),
  RouteGetter.get('project').adminPath(),
];

if (isDevMode) {
  projectFormPaths.push(RouteGetter.get('project').ordersPath());
  projectFormPaths.push(RouteGetter.get('project').orderPath());
}
export const projectForm = {
  path: projectFormPaths,
  component: Project,
} as DashboardRoute;

export const invitationPage = {
  path: '/dashboard/home/accept-invitation',
  component: InvitationPage,
} as RouteProps;

export const plansPricing = {
  path: '/dashboard/plans/pricing',
  component: Pricing,
} as DashboardRoute;

export const plansCheckout = {
  path: '/dashboard/plans/checkout',
  component: CheckoutPage,
} as DashboardRoute;

export default [
  home,
  invitationPage,
  profile,
  organizationEdit,
  projectList,
  projectForm,
  profileAll,
  plansPricing,
  plansCheckout,
];
